import { render } from "./SubmitTenantReview.vue?vue&type=template&id=145e517c&scoped=true&ts=true"
import script from "./SubmitTenantReview.vue?vue&type=script&lang=ts"
export * from "./SubmitTenantReview.vue?vue&type=script&lang=ts"

import "./SubmitTenantReview.vue?vue&type=style&index=0&id=145e517c&lang=scss&scoped=true"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-145e517c"]])

export default __exports__